var map = {
	"./blog-Abhinaya.png": "a8c1",
	"./blog-ajai_kannan.png": "04b8",
	"./blog-anto.png": "1203",
	"./blog-arun.png": "592f",
	"./blog-divya_gurunath.png": "e694",
	"./blog-goutham.png": "bf13",
	"./blog-nooreash.png": "5eec",
	"./blog-placeholder.png": "b5ff",
	"./blog-sruthi.png": "4029"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bbfd";